import { Link } from '@tanstack/react-router';

import { insideNativeApp } from '../auth/native-app';
import { isOwner } from '../auth/roles';
import { useSession } from '../auth/useSession';
import { formatTrialDate, trialWarningDue } from '../lib/trial';

const DAY_MS = 24 * 60 * 60 * 1000;

/** Calendar days from today to the trial's last day, in the owner's own timezone. */
function calendarDaysUntil(end: Date, now: Date): number {
  const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  return Math.round((startOfDay(end) - startOfDay(now)) / DAY_MS);
}

function whenWord(end: Date, now: Date): string {
  const days = calendarDaysUntil(end, now);
  if (days <= 0) return 'hoy';
  if (days === 1) return 'mañana';
  return `en ${days} días`;
}

/**
 * The last week of the free trial, for the owner: the day it ends and the
 * way to save the card, once, quietly above the work. Nothing before that
 * week, nothing once a card is saved (the session stops counting down), and
 * nothing for the team, who cannot save the card.
 */
export function TrialBanner() {
  const { session } = useSession();
  const trialEndsAt = session?.trialEndsAt;
  if (!trialEndsAt || !isOwner(session?.role) || !trialWarningDue(trialEndsAt) || insideNativeApp(session)) return null;
  const now = new Date();
  return (
    <p role="status" className="notice trial-banner">
      Tu prueba gratis termina el {formatTrialDate(trialEndsAt)}, {whenWord(new Date(trialEndsAt), now)}. Guarda tu tarjeta
      para seguir sin pausa. <Link to="/pago">Guardar tarjeta</Link>
    </p>
  );
}
